import { Address } from '../interfaces/address.interface';

export const getFullLocationFromAddress = (address: Address): string => {
    if (!address?.line1 || !address?.city || !address?.region || !address?.country || !address?.postalCode) {
        return '';
    }

    const addressLines = `${address.line1} ${address.line2 ?? ''}`.trim();

    return `${addressLines}, ${address.city}, ${address.region}, ${address.country}, ${address.postalCode}`.trim();
};
